<script setup lang="ts">
  import { message } from "ant-design-vue";
  import { computed, onMounted, onUnmounted, reactive, ref } from "vue";
  import { useRoute } from "vue-router";
  import kehuguanli from "~/assets/images/aigc/kehuguanli.png";
  // Import local images
  import shijianguanli from "~/assets/images/aigc/shijianguanli.png";
  import xiangmuguanli from "~/assets/images/aigc/xiangmuguanli.png";
  import CoreFunction from "~/components/aigc/CoreFunction.vue";
  import Anchor from "~/components/core/Anchor/Anchor.vue";
  import SettlementRight from "~/components/settlement/SettlementRight.vue";
  import { useAnchor } from "~/composables/useAnchor";
  import { useAnchorShow } from "~/composables/useAnchorShow";
  import { useApi, useReq } from "~/composables/useApi";
  import {
    AnYuanGuangChang1,
    FaLvJianSuo,
    FaLvWenShu,
    FaLvYanJiu,
    HeTongShenCha,
    NeiBuShiChang,
    ShangJiTuiSong,
    ShuZiMingPian,
    WenBenFenXi,
    WenDangGuanLi,
    XiaoLiZhiNengTi,
    ZhiShiKu,
  } from "~/enum/cdn";
  import { DLS_DOWNLOAD_URL, DLS_URL, LOGIN_URL, URL_LIST } from "~/env";
  import { useMainStore } from "~/stores";
  import Common from "~/utils/common";

  definePageMeta({
    layout: "nav-layout",
  });

  // useHead({
  //   title: "Paralegal",
  // });

  interface CarouselProps {
    icon: string;
    activeIcon?: string;
    title: string;
    desc: string;
    image: string;
  }

  interface SettlementRightProps {
    title: string;
    desc: string;
    imagePlacement: "left" | "right";
    anchorID?: string;
    btnEmit?: (...args: any[]) => void;
    carousel: CarouselProps[];
  }

  interface FunctionItem {
    functionName: string;
    functionDesc: string;
  }

  interface CoreFunctionProps {
    title: string;
    description?: string;
    url: string;
    mediaType?: "image" | "video";
    imagePlacement: "left" | "right";
    bg: "white" | "blue";
    anchorID: string;
    btnEmit: (...args: any[]) => void;
    functionList: FunctionItem[];
  }

  const route = useRoute();
  const req = useReq();
  const api = useApi();
  const store = useMainStore();

  // 跳转
  const toDls = (name: keyof typeof URL_LIST, hash?: string) => {
    if (name === "buyLogin") {
      location.replace(`${LOGIN_URL}&redirect=${encodeURIComponent(location.href + hash)}`);
      return;
    }
    location.href = URL_LIST[name];
  };
  const anchorList = [
    {
      id: "anchor1",
      title: "案源拓展",
      icon: "wenshu12",
      activeIcon: "wenshu11",
    },
    {
      id: "anchor2",
      title: "智慧办案",
      icon: "gaojijiansuo11",
      activeIcon: "gaojijiansuo13",
    },
    {
      id: "anchor3",
      title: "案件管理",
      icon: "jiqixuexi1",
      activeIcon: "jiqixuexi12",
    },
    {
      id: "anchor4",
      title: "知识管理",
      icon: "24gf-fileText13",
      activeIcon: "24gf-fileText17",
    },
    // {
    //   id: "anchor5",
    //   title: "小理AI",
    //   icon: "jiqiren1",
    //   activeIcon: "jiqiren11",
    // },
    {
      id: "anchor6",
      title: "小理智能体",
      icon: "jiqiren1",
      activeIcon: "jiqiren11",
    },
  ];
  const { curAnchorID } = useAnchor(anchorList);
  const toDownload = () => {
    Common.openWin(DLS_DOWNLOAD_URL);
  };
  const dlsList: SettlementRightProps[] = [
    {
      title: "案源拓展",
      desc: "用大数据和AI技术助力律师精准获客",
      anchorID: "anchor1",
      imagePlacement: "left",
      btnEmit: () => toDls("Dls"),
      carousel: [
        {
          icon: "moren1",
          activeIcon: "moren12",
          title: "数字名片",
          desc: "多维呈现专业形象、智能关联案件业绩、AI润色加持、一键分享微信朋友、数字追踪，让名片更体面，更快传播",
          image: ShuZiMingPian,
        },
        {
          icon: "kehu-2",
          activeIcon: "kehu-24",
          title: "案源广场",
          desc: "通过小理AI引流法律咨询需求， 根据律师的专业业绩、专业能力、用户口碑及个性化标签智能匹配客户",
          image: AnYuanGuangChang1,
        },
        {
          icon: "guizhangzhidufalvfagui-42",
          activeIcon: "guizhangzhidufalvfagui-422",
          title: "商机推送",
          desc: "越来越多的客户采取公开方式选聘律师，得理律助实时更新全国法律服务市场资讯，包括招标采购、涉诉公告等170w+商机数据，助力律师洞察市场先机",
          image: ShangJiTuiSong,
        },
        {
          icon: "Frame3522",
          activeIcon: "moren2",
          title: "内部市场 ",
          desc: "通过通讯录、智能推荐、寻求协作3种方式为律所打造内部市场，进行资源智能重组，激活沉睡案源",
          image: NeiBuShiChang,
        },
      ],
    },
    {
      title: "智慧办案",
      desc: "通过AI重塑办案流程，实现将法律检索、法律文书、合同生成及审查、案情证据分析等场景全链路智能化，为律师办案提速50%以上",
      anchorID: "anchor2",
      imagePlacement: "right",
      btnEmit: () => toDls("Dls"),
      carousel: [
        {
          icon: "tubiaozhinengjiansuomoren",
          activeIcon: "tubiaozhinengjiansuomoren2",
          title: "法律检索",
          desc: "覆盖案例、法规、专利、商标、域名等5亿+全域法律数据，语义、关键词、长文本多重检索模式加持",
          image: FaLvJianSuo,
        },
        {
          icon: "Group1940700081",
          activeIcon: "Group1940700053",
          title: "法律研究",
          desc: "法律实务、法律学术、法律问题等深度研究，同步输出法律研究报告",
          image: FaLvYanJiu,
        },
        {
          icon: "Group1940700080",
          activeIcon: "Group1940700051",
          title: "法律文书",
          desc: "智能生成+精准转换，完成标准与灵活兼备的诉讼文书与非诉文书",
          image: FaLvWenShu,
        },
        {
          icon: "Group1940700082",
          activeIcon: "Group1940700055",
          title: "智能合同",
          desc: "分步引导，精准起草自己想要的合同；精准识别合同风险，一键完成修订",
          image: HeTongShenCha,
        },
        {
          icon: "shuju22",
          activeIcon: "shuju221",
          title: "文本分析",
          desc: "案件分析、证据分析、合同分析、资料解读，多文档梳理分析",
          image: WenBenFenXi,
        },
      ],
    },
    {
      title: "案件管理",
      desc: "给每位律师配备的智慧秘书，通过案件管理工作流，帮助律师更好地管理客户和在办案件，提升工作效率",
      anchorID: "anchor3",
      imagePlacement: "left",
      btnEmit: () => toDls("Dls"),
      carousel: [
        {
          icon: "kehu-21",
          activeIcon: "kehu-25",
          title: "客户管理",
          desc: "律师价值可视化呈现，实现客户管理数据化",
          image: kehuguanli,
        },
        {
          icon: "xiangmu-1",
          activeIcon: "xiangmu-12",
          title: "项目管理",
          desc: "通过合同、客户、项目、任务的智能办案工作流，明晰律师工作线条，让律师高效协同办案",
          image: xiangmuguanli,
        },
        // {
        //   icon: "bianzu-16",
        //   activeIcon: "bianzu-161",
        //   title: "项目管理",
        //   desc: "随时随地审批业务，工作处理尽在掌握",
        //   image: shengpiguanli,
        // },
        {
          icon: "bianzu5-e7lbhi4h",
          activeIcon: "bianzu4-e7l5jm1p",
          title: "时间管理",
          desc: "量化律师价值，优化工作节奏",
          image: shijianguanli,
        },
      ],
    },
    {
      title: "知识管理",
      desc: "专为律师打造的高效、便捷、安全的知识管理解决方案",
      anchorID: "anchor4",
      imagePlacement: "right",
      btnEmit: () => toDls("Dls"),
      carousel: [
        {
          icon: "huiyunpan1",
          activeIcon: "huiyunpan12",
          title: "数字云盘",
          desc: "海量存储空间，文件、图片轻松容纳，自动多端同步，助力律师随时随地管理文档资产",
          image: WenDangGuanLi,
        },
        {
          icon: "bianzu-12",
          activeIcon: "bianzu-121",
          title: "多人协作",
          desc: "支持项目文件共享，多人协作，在线编辑",
          image: WenDangGuanLi,
        },
        {
          icon: "Frame3519",
          activeIcon: "bianzu-13-e7lbhi0o",
          title: "智能辅助",
          desc: "得理律助搭载自研的法律AI大模型，具备海量的文本库知识，能辅助律师撰写各类文档",
          image: WenDangGuanLi,
        },
        {
          icon: "Group1940700080-k871ddhc",
          activeIcon: "Group1940700068",
          title: "知识库",
          desc: "专为律师律所打造「管理+共享+应用」三位一体的知识中枢，让经验高效流转",
          image: ZhiShiKu,
        },
      ],
    },
  ];
  const coreList: CoreFunctionProps[] = [
    // {
    //   title: "小理AI",
    //   description:
    //     "用最前沿的AI大模型算法技术训练海量法律数据，打造的最强智能法律大脑，专为律师定制的指令集让律师工作10倍增效",
    //   url: XiaoLiAi,
    //   anchorID: "anchor5",
    //   bg: "blue",
    //   mediaType: "video",
    //   imagePlacement: "left",
    //   btnEmit: () => toDls("Dls"),
    //   functionList: [
    //     {
    //       functionName: "对话检索：",
    //       functionDesc: "跟小理AI聊天，随时随地查找法条、案例，让复杂的法律检索跟聊天一样简单",
    //     },
    //     {
    //       functionName: "案情分析：",
    //       functionDesc: "根据给定的案情，小理AI可以对案件所涉及的法律问题和裁判观点进行分析",
    //     },
    //     {
    //       functionName: "文书写作：",
    //       functionDesc: "帮助律师撰写各类工作文档，比如起诉书、答辩状、营销文案、客户邮件、会议备忘等",
    //     },
    //     {
    //       functionName: "知识学习：",
    //       functionDesc: "小理AI学习了包含法律在内的各类知识库，律师可以向小理AI咨询各类问题，学习各类知识",
    //     },
    //     {
    //       functionName: "行业研究：",
    //       functionDesc: "律师借助小理AI研究客户所在行业的背景资讯，提升客户服务能力",
    //     },
    //   ],
    // },
    {
      title: "小理智能体",
      description: "辅助律师完成营销拓客、客户服务、服务报告等工作，让律师专注复杂法律事务解决",
      url: XiaoLiZhiNengTi,
      anchorID: "anchor6",
      bg: "white",
      imagePlacement: "right",
      btnEmit: () => toDls("Dls"),
      functionList: [
        {
          functionName: "名片智能体：",
          functionDesc:
            "打破传统名片边界，用名片实现客户裂变，AI技术个性化设计律师专属数字名片和简介，全方面展示专业形象",
        },
        {
          functionName: "客服智能体：",
          functionDesc: "链接小理AI，随时随地解答客户各类问题，让律师在忙碌时仍能及时回复客户咨询",
        },
        {
          functionName: "合同智能体：",
          functionDesc: "依托海量历史合同数据沉淀，AI 智能检索分析历史签约客户全貌，生成律师的客户服务报告",
        },
        {
          functionName: "利冲智能体：",
          functionDesc:
            "依据客户与对方当事人信息，AI智能检测并分类检索存在利益冲突、疑似冲突或无利益冲突的案件列表，为风险管控提供清晰参考",
        },
      ],
    },
  ];
  const featureCategories = [
    {
      name: "案源拓展",
      features: ["数字名片", "案源广场", "商机推送", "内部市场"],
    },
    {
      name: "智慧办案",
      features: ["法律检索", "法律研究", "法律文书", "智能合同", "文本分析"],
    },
    {
      name: "案件管理",
      features: ["客户管理", "项目管理", "时间管理"],
    },
    {
      name: "知识管理",
      features: ["数字云盘", "智能辅助", "知识库"],
    },
    {
      name: "小理智能体",
      features: ["名片智能体", "客服智能体", "合同智能体", "利冲智能体"],
    },
  ];
  const vipList = [
    {
      title: "律助个人版",
      desc: "适合个人使用",
      prices: "75/",
      discount: "最高可打8.5折",
      limit: "",
      btnText: "立即购买",
      recommended: false,
      excludeFeatures: ["内部市场", "知识库", "合同智能体", "利冲智能体"],
    },
    {
      title: "律助团队版",
      desc: "适合10人以内的团队使用",
      prices: "83/",
      discount: "",
      limit: "3个账号起购",
      btnText: "立即购买",
      recommended: false,
      excludeFeatures: ["内部市场", "知识库", "合同智能体", "利冲智能体"],
    },
    {
      title: "律助机构版",
      desc: "适合律所使用",
      prices: "83/",
      discount: "",
      limit: "10个账号起购",
      btnText: "咨询顾问购买",
      recommended: true,
      excludeFeatures: [],
    },
  ];
  const isIncluded = (plan: any, feature: string) => !plan.excludeFeatures.includes(feature);

  const currentType = ref("productConsult");
  const state = reactive({
    isBuyModal: false, // 对话框显示
    buyModalLoading: false,
  });
  const onConsult = () => {
    currentType.value = "productConsult";
    state.isBuyModal = true;
    state.buyModalLoading = true;
  };
  //  对话框数据
  const modalData: any = {
    // 扫码咨询
    productConsult: {
      url: `${DLS_URL}/product/consult`,
      height: "490px",
      width: "52.5rem",
    },
    // 个人方案选择
    productPurchasePlan: {
      url: `${DLS_URL}/product/purchasePlanDls?cId=`,
      height: "722px",
      width: "1323px",
    },
    //团队方案选择
    productPurchaseTeamPlan: {
      url: `${DLS_URL}/product/PurchaseTeamPlanDls?cId=`,
      height: "740px",
      width: "1390px",
    },
    // 阶梯计费标准
    productChargingStandards: {
      url: `${DLS_URL}/product/chargingStandards`,
      height: "534px",
      width: "75rem",
    },
    // 选择团队
    productSelectTeam: {
      url: `${DLS_URL}/product/selectTeam`,
      height: "740px",
      width: "75rem",
    },
    // 订单支付
    productOrderPay: {
      url: `${DLS_URL}/product/orderPay/:id`,
      height: "740px",
      width: "75rem",
    },
    // 支付结果
    productOrderPayResult: {
      url: `${DLS_URL}/product/orderPayResult/:id`,
      height: "740px",
      width: "75rem",
    },
  };
  const curModalData = computed(() => {
    return modalData[currentType.value];
  });
  const onIframeLoad = () => {
    state.buyModalLoading = false;
  };

  // 打开对话框
  const onOpenModal = (type: string) => {
    req
      .auth()
      .then(() => {
        currentType.value = type;
        if (type === "productPurchasePlan" && !store.personCorpId) {
          message.warn("当前用户没有个人版,无法进行购买!");
          return;
        }
        state.isBuyModal = true;
        state.buyModalLoading = true;
      })
      .catch(() => {
        toDls("buyLogin", "#buyArea");
      });
  };

  const onBuy = (index: number) => {
    if (index === 0) {
      // 立即购买
      onOpenModal("productPurchasePlan");
    } else if (index === 1) {
      onOpenModal("productPurchaseTeamPlan");
    } else {
      // 咨询购买
      onConsult();
    }
  };

  const handleMessage = (event: any) => {
    if (event.data === "close") state.isBuyModal = false;
  };

  const dlsVip = ref<HTMLElement | null>(null);

  const onPosition = (type?: string): void => {
    if (type) {
      const refMap: Record<string, HTMLElement | null> = {
        dlsVip: dlsVip.value,
      };

      refMap[type]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // 特殊埋点
  const postSpecialTrack = () => {
    api.ai.specialTrack({ referer: window.location.href });
  };

  onMounted(() => {
    postSpecialTrack();
    const type = route.query.type as string;

    setTimeout(() => {
      onPosition(type);
    }, 200);
    window.addEventListener("message", handleMessage);
  });

  onUnmounted(() => {
    window.removeEventListener("message", handleMessage);
  });

  const { anchorShow } = useAnchorShow();
</script>

<template>
  <div class="legal-dls">
    <Anchor v-show="anchorShow" :id="curAnchorID" :anchor="anchorList" />
    <div id="anchor-start" class="legal-dls-banner tw-font">
      <div class="legal-dls-banner-content">
        <p>- 得理律助 -</p>
        <p>专为律师打造的智能助手</p>
        <p>律师行业数智化转型方案专家</p>
        <div class="legal-dls-btns">
          <a-button @click="toDls('Dls')">免费体验</a-button>
          <a-button class="app-download-btn app-download-mobile" @click="toDownload">APP下载</a-button>
          <a-button class="app-download-btn app-download-pc">APP下载</a-button>
          <img class="qrcode" src="~/assets/images/qrcode/paralegal.png" />
        </div>
      </div>
    </div>
    <div
      v-for="(right, idx) of dlsList"
      :key="idx"
      class="settlement-rights-box"
      :class="`settlement-rights-box${idx}`">
      <SettlementRight class="anchor-content" v-bind="right" />
    </div>
    <CoreFunction v-for="item of coreList" v-bind="item" :key="item.anchorID" class="anchor-content" />
    <div id="anchor-end" ref="dlsVip" class="legal-dls-vip">
      <h3>产品定价</h3>
      <p>根据您的规模与实际情况，选择相应的版本</p>
      <div class="vip-table-wrap">
        <table class="vip-table">
          <colgroup>
            <col class="col-category" />
            <col class="col-feature" />
            <col class="col-plan" />
            <col class="col-plan" />
            <col class="col-plan" />
          </colgroup>
          <thead>
            <tr>
              <th colspan="2" class="vip-th-label">功能对比</th>
              <th
                v-for="(plan, idx) in vipList"
                :key="idx"
                class="vip-th-plan"
                :class="{ 'is-recommended': plan.recommended, 'has-discount': !!plan.discount }">
                <div v-if="plan.discount" class="plan-discount">{{ plan.discount }}</div>
                <div v-if="plan.recommended" class="plan-recommend">推荐</div>
                <div class="plan-title">{{ plan.title }}</div>
                <div class="plan-desc">{{ plan.desc }}</div>
                <div class="plan-price">
                  <span class="price-prefix">低至¥</span>
                  <span class="price-num">{{ plan.prices }}</span>
                  <span class="price-suffix">月</span>
                </div>
                <div class="plan-limit" v-if="plan.limit">{{ plan.limit }}</div>
                <a-popover
                  v-if="plan.recommended"
                  trigger="click"
                  overlay-class-name="consult-qrcode-popover"
                  placement="bottom">
                  <template #content>
                    <div class="consult-qrcode-box">
                      <img src="~/assets/images/qrcode/paralegal.png" />
                      <div class="consult-qr-divider"></div>
                      <p>微信扫码</p>
                      <p>添加专属顾问</p>
                    </div>
                  </template>
                  <a-button class="btn-orange">{{ plan.btnText }}</a-button>
                </a-popover>
                <a-button v-else @click="onBuy(idx)">{{ plan.btnText }}</a-button>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="category in featureCategories" :key="category.name">
              <tr v-for="(feature, fi) in category.features" :key="feature" class="vip-feature-row">
                <td v-if="fi === 0" :rowspan="category.features.length" class="vip-td-category">
                  {{ category.name }}
                </td>
                <td class="vip-td-feature">{{ feature }}</td>
                <td v-for="(plan, pi) in vipList" :key="pi" class="vip-td-check">
                  <icon-font class="tw-text-[26px]" v-if="isIncluded(plan, feature)" type="Group1940699958" />
                  <span v-else class="feature-dash">—</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="legal-dls-platform-box">
      <div class="legal-dls-platform">
        <img class="legal-dls-platform-left" src="~/assets/images/legal-dls/computer.png" />
        <div class="legal-dls-platform-right">
          <h3>灵活订阅，多端使用</h3>
          <div class="legal-dls-platform-label">
            <span>协同使用</span>
            <span>指尖办公</span>
          </div>
          <div class="legal-dls-platform-qrcode">
            <img src="~/assets/images/legal-dls/qrcode.png" />
            <div class="legal-dls-platform-qrcode-text">
              <div>扫描左侧二维码</div>
              <div> 下载得理律助APP，随时随地使用</div>
            </div>
          </div>
          <a-button @click="toDls('Dls')">免费体验</a-button>
        </div>
      </div>
    </div>
    <a-modal
      v-model:open="state.isBuyModal"
      :width="curModalData.width"
      :wrap-class-name="`${
        !['productPurchasePlan', 'productPurchaseTeamPlan'].includes(currentType) ? ''
        : state.buyModalLoading ? 'purchase-plan-dls purchase-plan-dls-loading'
        : 'purchase-plan-dls'
      }`"
      :footer="null"
      :mask-closable="false">
      <a-spin :spinning="state.buyModalLoading">
        <div class="iframe-box" :style="`height: ${curModalData.height}`">
          <iframe
            v-if="state.isBuyModal"
            v-show="!state.buyModalLoading"
            class="iframe-container"
            :src="currentType === 'productPurchasePlan' ? curModalData.url + store.personCorpId : curModalData.url"
            frameborder="no"
            border="0"
            marginwidth="0"
            marginheight="0"
            scrolling="no"
            allowtransparency="true"
            @load="onIframeLoad()">
          </iframe>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<style scoped lang="less">
  .legal-dls {
    --banner-title-text: 86px;
    --banner-title-leading: 101px;
    --banner-sub-title-text: 36px;
    --banner-sub-title-leading: 42px;
    --banner-btn-text: 24px;
    --banner-btn-leading: 28px;
    --banner-btn-width: 200px;
    --banner-btn-height: 72px;
    --banner-btn-download-pc: block;
    --banner-btn-download-mobile: none;
    --platform-flex-wrap: nowrap;
    --platform-left-width: 0;
    --platform-right-min-width: 432px;
    --platform-right-align-items: flex-start;
    --platform-qrcode-justify: flex-start;

    timeline-scope: --t1, --t2, --t3, --t4, --t5, --t6;

    @media (max-width: 1024px) {
      --banner-title-text: 66px;
      --banner-title-leading: 79px;
      --platform-flex-wrap: wrap;
      --platform-left-width: 100%;
      --platform-right-min-width: fit-content;
      --platform-right-align-items: center;
      --platform-qrcode-justify: center;
    }

    @media (max-width: 768px) {
      --banner-title-text: 56px;
      --banner-title-leading: 66px;
      --banner-btn-text: 16px;
      --banner-btn-leading: 20px;
      --banner-btn-width: 126px;
      --banner-btn-height: 42px;
      --banner-btn-download-pc: none;
      --banner-btn-download-mobile: block;
    }

    @media (max-width: 640px) {
      --banner-title-text: 38px;
      --banner-title-leading: 46px;
    }

    @media (max-width: 480px) {
      --banner-sub-title-text: 26px;
      --banner-sub-title-leading: 32px;
      --banner-title-text: 28px;
      --banner-title-leading: 36px;
    }

    .legal-dls-banner {
      height: 945px;
      overflow: hidden;
      background-image: url("~/assets/images/legal-dls/banner.png");
      background-position: center;
      background-size: cover;

      .legal-dls-banner-content {
        width: min-content();
        margin: 172px auto 0;

        p {
          padding: 0 32px;
          margin-bottom: 0;
          font-size: var(--banner-title-text);
          font-weight: bolder;
          line-height: var(--banner-title-leading);
          color: #fff;
          text-align: center;

          &:nth-of-type(1) {
            margin-bottom: 24px;
            font-size: var(--banner-sub-title-text);
            line-height: var(--banner-sub-title-leading);
          }
        }

        .legal-dls-btns {
          position: relative;
          display: flex;
          gap: 28px;
          align-items: center;
          justify-content: center;
          width: min-content;
          margin: 167px auto 0;

          .ant-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: var(--banner-btn-width);
            height: var(--banner-btn-height);
            font-size: var(--banner-btn-text);
            font-weight: 600;
            line-height: var(--banner-btn-leading);
            color: #fff;
            background: linear-gradient(90deg, #3858ff 0%, #66f 100%);
            border: none !important;
            border-radius: 4px;
          }

          .app-download-btn {
            color: #0a5cff;
            background-color: white;
            background-image: none;
          }

          .app-download-mobile {
            display: var(--banner-btn-download-mobile);
          }

          .app-download-pc {
            display: var(--banner-btn-download-pc);

            &:hover {
              & ~ .qrcode {
                width: 155px;
              }
            }
          }

          .qrcode {
            position: absolute;
            top: 50%;
            right: 0;
            width: 0;
            height: 155px;
            transform: translateX(calc(100% + 28px)) translateY(-50%);
          }
        }
      }
    }

    .settlement-rights-box {
      padding: 116px 16px 0;
      background-position: center;
      background-size: cover;

      &.settlement-rights-box0 {
        min-height: 1163px;
        padding-top: 192px;
        background-image: url("~/assets/images/aigc/bg-2.png");
      }

      &.settlement-rights-box1 {
        min-height: 1080px;
        background-image: url("~/assets/images/aigc/bg-1.png");
      }

      &.settlement-rights-box2 {
        min-height: 1074px;
        background-image: url("~/assets/images/aigc/bg-2.png");
      }

      &.settlement-rights-box3 {
        position: relative;
        min-height: 1080px;
        background-image: url("~/assets/images/aigc/bg-1.png");
      }

      .ant-btn {
        position: absolute;
        bottom: 175px;
        left: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1264px;
        height: 97px;
        font-size: var(--banner-btn-text);
        font-weight: normal;
        line-height: var(--banner-btn-leading);
        color: #7d4242;
        background: linear-gradient(90deg, #ffc063 0%, #ffedd4 50%, #ffc063 100%);
        border: none !important;
        border-radius: 98px;
        transform: translateX(-50%);
      }
    }

    :deep(.carousel-component) {
      background-color: transparent;
    }

    .legal-dls-vip {
      min-height: 1334px;
      padding: 16px 0;
      overflow: hidden;
      background-image: url("~/assets/images/aigc/bg-2.png");
      background-position: center;
      background-size: cover;

      h3 {
        display: flex;
        gap: 16px;
        place-content: center center;
        margin-top: 96px;
        margin-bottom: 14px;
        font-size: 40px;
        font-weight: 600;
        line-height: 47px;
        color: #333;

        &::before,
        &::after {
          display: block;
          width: 10px;
          height: 9px;
          margin: auto 0;
          content: "";
          background: linear-gradient(90deg, #0a5cff 0%, #54b7ff 100%);
        }
      }

      p {
        margin-bottom: 72px;
        font-size: 24px;
        font-weight: 400;
        line-height: 28px;
        color: #9da1b6;
        text-align: center;
      }

      .vip-table-wrap {
        max-width: 1200px;
        margin: 0 auto;
        overflow-x: auto;

        @media (max-width: 768px) {
          .vip-table {
            min-width: 600px;

            .vip-th-plan {
              padding: 16px 8px;

              &.has-discount {
                padding-top: 46px;
              }

              .plan-discount {
                width: 100%;
                font-size: 12px;
                border-radius: 0;
              }

              .plan-title {
                font-size: 14px;
              }

              .plan-desc {
                display: none;
              }

              .plan-price .price-num {
                font-size: 24px;
              }

              .ant-btn {
                position: static;
                width: 100%;
                height: 34px;
                font-size: 13px;
                transform: none;
              }
            }

            .vip-th-label {
              padding: 16px 8px;
              font-size: 16px;
            }

            .vip-td-category,
            .vip-td-feature {
              padding: 0 8px;
              font-size: 13px;
            }
          }
        }

        .vip-table {
          width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
          background: #fff;
          border: 1px solid #e3e3e3;

          .col-category {
            width: 16.5%;
          }

          .col-feature {
            width: 16.5%;
          }

          .col-plan {
            width: 22.3%;
          }

          .vip-th-label {
            padding: 40px 24px 32px;
            font-size: 24px;
            font-weight: 600;
            color: #333;
            text-align: center;
            // vertical-align: bottom;
            border-right: 1px solid #e3e3e3;
            border-bottom: 1px solid #e3e3e3;
          }

          .vip-th-plan {
            position: relative;
            padding: 32px 24px 62px;
            overflow: hidden;
            // text-align: center;
            vertical-align: top;
            border-bottom: 1px solid #e3e3e3;
            border-left: 1px solid #e3e3e3;

            &.has-discount {
              padding-top: 40px;
            }

            .plan-discount {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 170px;
              height: 30px;
              font-size: 16px;
              color: #fff;
              background: #f46a3e;
              border-radius: 0 0 0 16px;
            }

            .plan-recommend {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 9.125rem;
              height: 1.875rem;
              font-size: 1.25rem;
              line-height: 1.4375rem;
              color: #fff;
              background: #f46a3e;
              transform: rotate(45deg) translateY(-40%) translate(30%);
              transform-origin: center;

              // &::after {
              //   position: absolute;
              //   top: -56px;
              //   right: 2px;
              //   font-size: 14px;
              //   font-weight: 600;
              //   color: #fff;
              //   white-space: nowrap;
              //   content: "推荐";
              // }
            }

            .plan-title {
              margin-bottom: 6px;
              font-size: 20px;
              font-weight: 600;
              color: #333;
              text-align: left;
            }

            .plan-desc {
              margin-bottom: 12px;
              font-size: 14px;
              color: #666;
              text-align: left;
            }

            .plan-price {
              display: flex;
              align-items: baseline;
              // justify-content: center;
              margin-bottom: 4px;

              .price-prefix {
                font-size: 16px;
                color: #f46a3e;
              }

              .price-num {
                margin: 0 2px;
                font-size: 40px;
                font-weight: 600;
                line-height: 1;
                color: #ee7115;
              }

              .price-suffix {
                font-size: 16px;
                color: #f46a3e;
              }
            }

            .plan-limit {
              height: 24px;
              margin-bottom: 16px;
              font-size: 14px;
              color: #f46a3e;
              text-align: left;
            }

            .ant-btn {
              position: absolute;
              bottom: 20px;
              left: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 197px;
              height: 42px;
              font-size: 18px;
              color: #fff;
              background: linear-gradient(90deg, #0a5cff 0%, #54b7ff 100%);
              border: none;
              border-radius: 60px;
              transform: translateX(-50%);

              &.btn-orange {
                background: #f46a3e;
              }
            }
          }

          .vip-td-category {
            padding: 12px 16px;
            font-size: 17px;
            color: #000;
            text-align: center;
            vertical-align: middle;
            border-right: 1px solid #e3e3e3;
            border-bottom: 1px solid #e3e3e3;
          }

          .vip-td-feature {
            height: 64px;
            padding: 0 16px;
            font-size: 17px;
            color: #000;
            text-align: center;
            vertical-align: middle;
            border-right: 1px solid #e3e3e3;
            border-bottom: 1px solid #e3e3e3;
          }

          .vip-td-check {
            height: 64px;
            text-align: center;
            vertical-align: middle;
            border-bottom: 1px solid #e3e3e3;
            border-left: 1px solid #e3e3e3;

            .anticon {
              font-size: 26px;
            }

            .feature-dash {
              font-size: 20px;
              color: #ccc;
            }
          }
        }
      }
    }

    .legal-dls-platform-box {
      min-height: 1080px;
      padding: 280px 16px;
      background-image: url("~/assets/images/aigc/bg-1.png");
      background-position: center;
      background-size: cover;

      .legal-dls-platform {
        display: flex;
        flex-wrap: var(--platform-flex-wrap);
        gap: 66px;
        align-items: center;
        justify-content: center;
        max-width: 1312px;
        margin: 0 auto;

        .legal-dls-platform-left {
          flex: 1;
          width: var(--platform-left-width);
          height: auto;
          aspect-ratio: 814 /523;
          object-fit: cover;
        }

        .legal-dls-platform-right {
          display: flex;
          flex-direction: column;
          align-items: var(--platform-right-align-items);
          min-width: var(--platform-right-min-width);

          h3 {
            margin-bottom: 35px;
            font-size: 48px;
            font-weight: 600;
            line-height: 56px;
            color: #1d2129;
          }

          .legal-dls-platform-label {
            display: flex;
            flex-wrap: wrap;
            gap: 26px;
            align-items: center;
            margin-bottom: 85px;

            span {
              padding: 16px 28px;
              font-size: 16px;
              line-height: 19px;
              color: #4e5969;
              border: 1px solid #b9c5d2;
            }
          }

          .legal-dls-platform-qrcode {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            align-items: center;
            justify-content: var(--platform-qrcode-justify);
            margin-bottom: 85px;

            img {
              width: 154px;
              height: 154px;
              object-fit: cover;
            }

            .legal-dls-platform-qrcode-text {
              span {
                font-size: 16px;
                line-height: 19px;
                color: #4e5969;
              }
            }
          }

          .ant-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 180px;
            height: 64px;
            font-size: 20px;
            line-height: 23px;
            color: #fff;
            background: linear-gradient(90deg, #0a5cff 0%, #54b7ff 100%);
            border-radius: 4px;
          }
        }
      }
    }
  }

  .iframe-container {
    width: 100%;
    height: 100%;
  }

  :deep(.purchase-plan-dls) {
    .ant-modal {
      width: inherit !important;
      max-width: 1323px !important;

      .ant-modal-content {
        min-height: 722px !important;
        background-color: transparent;

        .ant-modal-body {
          padding: 0;

          .ant-spin {
            max-height: none !important;
          }

          .iframe-box {
            min-height: 722px !important;

            @media only screen and (max-width: 1024px) {
              min-height: 1400px !important;
            }
          }
        }
      }
    }
  }

  :deep(.purchase-plan-dls-loading .ant-modal-content) {
    background-color: #fff !important;
  }
</style>
<style lang="less">
  .legal-dls {
    .consult-qrcode-popover {
      .ant-popover-arrow {
        &::before {
          background: #faad96;
        }
      }

      .ant-popover-inner {
        padding: 16px;
        background: #fff;
        border: 1px solid #faad96;
        border-radius: 20px;
        box-shadow: 0 4px 8px rgba(110, 110, 110, 20%);
      }

      .consult-qrcode-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 165px;

        img {
          display: block;
          width: 132px;
          height: 132px;
          object-fit: contain;
        }

        .consult-qr-divider {
          width: 122px;
          height: 1px;
          margin: 12px 0;
          background: #e8e8e8;
        }

        p {
          margin: 0;
          font-size: 14px;
          line-height: 1.6;
          color: #999;
          text-align: center;
        }
      }
    }
  }
</style>
